import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

interface InputSearchProps {
  label: string;
  defaultValue?: string;
  onSearch: (value: string) => void;
  handleClearInput: () => void; // Recebe a função de limpar como prop
}

const InputSearch: React.FC<InputSearchProps> = ({
  label,
  defaultValue = '',
  onSearch,
  handleClearInput,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  const clearFilterCPFChange = () => {
    setInputValue('');
  };

  // Função para aplicar a máscara de CPF ou CNPJ
  const applyMask = (value: string): string => {
    value = value.replace(/\D/g, ''); // Remove qualquer coisa que não seja número

    if (value.length <= 11) {
      // Máscara para CPF
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (value.length > 11 && value.length <= 14) {
      // Máscara para CNPJ
      return value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      );
    }
    return value;
  };

  // Lidar com as mudanças no input e aplicar a máscara
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const maskedValue = applyMask(value);
    setInputValue(maskedValue);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      justifyContent="space-between"
      sx={{ width: '100%' }}
    >
      <TextField
        value={inputValue}
        onChange={handleInputChange}
        label={label}
        variant="outlined"
        fullWidth
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
          },
        }}
        slotProps={{
          inputLabel: {
            sx: {
              fontSize: '14px',
              lineHeight: '40px', // Alinha verticalmente com o input
              top: 0,
              transform: 'translate(14px, 0)', // Posição normal (não shrink)
              transition: 'all 0.2s ease', // Transição suave
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75)', // Sobe ao focar ou digitar
                lineHeight: 'normal', // Retira alinhamento vertical no modo shrink
              },
            },
          },
          htmlInput: {
            maxLength: 18, // Limita a entrada a 14 caracteres (máximo de CPF ou CNPJ)
          },
        }}
      />

      {/* Botão de limpar, usa a função recebida via prop */}
      <IconButton
        onClick={() => {
          handleClearInput();
          clearFilterCPFChange();
        }}
        sx={{ padding: 1 }}
      >
        <RefreshIcon />
      </IconButton>

      <Button
        variant="contained"
        onClick={() => onSearch(inputValue)}
        sx={{
          height: '40px',
          alignSelf: 'center',
          paddingX: '30px',
          fontSize: {
            xs: '0.55rem', // Mobile: menor fonte
            sm: '0.875rem', // A partir do sm: tamanho normal
          },
        }}
      >
        Pesquisar
      </Button>
    </Box>
  );
};

export default InputSearch;
